import { render, staticRenderFns } from "./ArticleItemView.vue?vue&type=template&id=a6fdd744&scoped=true&"
import script from "./ArticleItemView.vue?vue&type=script&lang=js&"
export * from "./ArticleItemView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItemView.vue?vue&type=style&index=0&id=a6fdd744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fdd744",
  null
  
)

export default component.exports